module.exports = __webpack_public_path__ + "static/media/WBNB2B_Industrial_manufacturers_global_exporters_B2B_2_India.0a17d681.png";